import './selectbar.css';
import Flaticon from "../flaticon/flaticon";
import useSettings from "../../hooks/useSettingsApi";
import textJson from '../../text/text.json'
function Selectbar(props) {
    const data = props.data
    const nearLocation = props.nearLocation
    const settings = useSettings();
    const singular_text = settings ? settings.singular ? settings.singular : textJson.singular_text : textJson.singular_text
    const plural_text = settings ? settings.plural ? settings.plural : textJson.plural_text : textJson.plural_text

    return (
        <div  className={`selectbar ${props.className}`}>
            <select defaultValue={props.defaultValue} onChange={props.handleSelectChange} id={'styledSelect1'} name="pets">
                <option value="" disabled hidden>La liste de nos {plural_text}</option>
                <optgroup label={'Proche de vous'}>
                    {props.haveLocation ? (nearLocation ? nearLocation.map((e,i)=>{
                        return <option key={`SelectbarNear-${i}`} value={e.title.rendered}>{typeof e.sl_distance !== "undefined" ? '( ≈ '+ (Math.round(e.sl_distance/1000) > 0 ? `${Math.round(e.sl_distance/1000)} km` : `${e.sl_distance} m`) + ')' : ''} {e.title.rendered}</option>
                    }) : <option value='disable' disabled={true}>Aucun {singular_text} proche de vous</option>)
                        : <option value='disable' disabled={true}>La geolocalisation est désactivée</option>
                    }
                </optgroup>
                <optgroup label={`Autres ${plural_text}`}>
                    {data ? data.map((e,i)=>{
                        return <option key={`Selectbar-${i}`} value={e.title.rendered}>{typeof e.sl_distance !== "undefined" ? '( ≈ '+ (Math.round(e.sl_distance/1000) > 0 ? `${Math.round(e.sl_distance/1000)} km` : `${e.sl_distance} m`) + ')' : ''} {e.title.rendered}</option>
                    }) : ''}
                </optgroup>
            </select>
            <a className={'select-open-button'} href="#"><Flaticon icon={'down-chevron'}/></a>
        </div>
    );
}

export default Selectbar;
